/* src/interviews/components/AvailabilityHeader/styles.js */

export default theme => ({
  expand: {
    margin: theme.spacing.unit,
    marginLeft: 'auto',
  },
});



// WEBPACK FOOTER //
// ./src/modules/interviews/components/AvailabilityHeader/styles.js